const EMP_CODE_KEY = 'emp_code';

const getEmpCode = () => {
  return localStorage.getItem(EMP_CODE_KEY);
};

const setEmpCode = (empCode: string) => {
  localStorage.setItem(EMP_CODE_KEY, empCode);
};

const clearEmpCode = () => {
  localStorage.removeItem(EMP_CODE_KEY);
};

// TODO-获取用户头像-无测试环境
const getAvatarByAccount = async (empCode: string) => {
  const { default: MD5 } = await import('crypto-js/md5');
  const md5Str = MD5(`${empCode}*&^SFIMIMAGE^&*1${empCode}`).toString();
  const getAvatarUrl =  "//srs.sf-express.com/fileimage/img_" + md5Str + ".jpg"
  return getAvatarUrl
};

export { EMP_CODE_KEY, getEmpCode, setEmpCode, clearEmpCode, getAvatarByAccount };
